import { createFeatureSelector, createSelector } from '@ngrx/store';

import { State, dashboardFeatureKey } from './dashboard.reducer';
import { fromCore } from '@core/store';
import { TreeViewHelper } from '@shared/gui/helpers/tree-view.helper';
import { Equipment } from '@shared/gui/models/equipment.model';
import { SimulatedEquipment } from '../../topology/models/simulatedEquipment.model';
import { Dashboard, DashboardComponent, DashboardComponentType, DashboardLimitedData } from '../models/dashboard.model';
import { DateTime } from 'luxon';
import { TimestreamMetric } from '@app/home/models/metric.model';
import { CurrentSimulation } from '../../topology/models/current-simulation.model';
import { SimulationTimespan } from '@core/models/simulation-timespan';
import { TreeViewType } from '@shared/gui/models/tree-view.model';
import { FavoritePath } from '../../gas-block/models/favorite-path.model';
import { EquipmentHelper } from '@shared/gui/helpers/equipment.helper';
import { Referential } from '@core/models/referential.model';

const selectDashboardState = createFeatureSelector<State>(dashboardFeatureKey);

// Raw selectors

export const getIsListLoaded = createSelector(selectDashboardState, (state: State) => state.listLoaded);

export const getIsEditionLoaded = createSelector(selectDashboardState, (state: State) => state.editionLoaded);

export const getDashboard = createSelector(selectDashboardState, (state: State) => state.dashboard);

export const getDashboards = createSelector(selectDashboardState, (state: State) => state.dashboards);

export const getEdition = createSelector(selectDashboardState, (state: State) => state.edition);

export const getList = createSelector(selectDashboardState, (state: State) => state.list);

export const getToolbar = createSelector(selectDashboardState, (state: State) => state.toolbar);

export const getIndex = createSelector(selectDashboardState, (state: State) => state.index);

export const getTimeNavVisibility = createSelector(selectDashboardState, (state: State) => state.isTimeNavVisible);

export const getImagesToUpload = createSelector(selectDashboardState, (state: State) => state.imagesToUpload);

export const getImagesToRemove = createSelector(selectDashboardState, (state: State) => state.imagesToRemove);

export const getSimulatedEquipments = createSelector(selectDashboardState, (state: State) => state.simulatedEquipments);

export const getCurrentSimulation = createSelector(selectDashboardState, (state: State) => state.currentSimulation);

export const getSimulatedGroups = createSelector(selectDashboardState, (state: State) => state.simulatedGroups);

export const getRequestedDashbaord = createSelector(selectDashboardState, (state: State) => state.requestedDashboard);

export const getDashboardOrder = createSelector(selectDashboardState, (state: State) => state.orders);

// Calculated selectors

export const getDashboardTimespan = createSelector(
  getCurrentSimulation,
  (currentSimulation: CurrentSimulation) =>
    ({
      currentDate: currentSimulation.date,
      max: currentSimulation.max,
      min: currentSimulation.min
    }) as SimulationTimespan
);
/*
export const getSimulatedTreeView = createSelector(
  getSimulatedEquipments,
  fromCore.getEquipments,
  fromCore.getReferentials,
  (simulated: Array<SimulatedEquipment>, equipments: Array<Equipment>, referentials: Array<Referential>) => {
    const treeView = {};
    const zoneEBTs = EquipmentHelper.getZoneEbtNames(simulated);
    simulated.forEach(equipment => {
      TreeViewHelper.buildPartTreeView(treeView, equipment, equipments, referentials, zoneEBTs);
    });
    TreeViewHelper.storeTreeView('Kiara', treeView);
    return treeView;
  }
);*/

export const getSimulatedTreeViewEquipments = createSelector(
  getSimulatedEquipments,
  fromCore.getEquipments,
  fromCore.getReferentials,
  (simulated: Array<SimulatedEquipment>, equipments: Array<Equipment>, referentials: Array<Referential>) => {
    const treeView = {};
    const zoneEBTs = EquipmentHelper.getZoneEbtNames(simulated);
    simulated.forEach(equipment => {
      TreeViewHelper.buildPartTreeView(
        treeView,
        equipment,
        equipments,
        referentials,
        zoneEBTs,
        TreeViewType.SIMULATION
      );
    });
    return treeView;
  }
);

export const getFormatedDashboard = createSelector(
  getDashboard,
  fromCore.getEquipments,
  (dashboard: Dashboard, equipments) => {
    const components: Array<DashboardComponent> = [];
    dashboard?.components?.forEach(component => {
      let copy = component;
      if (component.type === DashboardComponentType.CURVE || component.type === DashboardComponentType.DIGITALMETER) {
        if (component.digitalMeter?.tag) {
          const treeViewPath = component.digitalMeter?.tag.split('|');
          const treeViewProperties = TreeViewHelper.getTreeViewPathProperties(treeViewPath);
          const equipment = equipments.find(e => e.id === treeViewProperties.category);
          if (!equipment) {
            console.log('wrong kiara tag, should not appear again');
            return;
          }
          const property = equipment.properties.find(p => p.name === treeViewProperties.measure);
          if (property?.unit) {
            copy = {
              ...component,
              digitalMeter: { ...component.digitalMeter, unit: property.unit }
            };
          }
        }
        if (component.curve?.data?.length) {
          const rawMetrics = component.curve.data[0].metrics;
          const metricsProperties = component.curve.metrics;
          const start = DateTime.fromISO(rawMetrics[0].timestamp);
          const end = DateTime.fromISO(rawMetrics[rawMetrics.length - 1].timestamp);

          const metrics: Array<TimestreamMetric> = [];
          component.curve.data.forEach((metricOutput, i) => {
            //const treeViewPath = component.curve.properties[i].split('>')[1].split('|');
            //const treeViewProperties = TreeViewHelper.getTreeViewPathProperties(treeViewPath, metricOutput.source);
            const metric = {
              ...metricsProperties[i],
              path: metricsProperties[i].pathJoin.split('|'),

              // key: treeViewProperties.key,
              // category: treeViewProperties.category,
              // ouvrage: treeViewProperties.ouvrage,
              // property: treeViewProperties.measure,
              // simulationType: +treeViewProperties.simulation,
              // path: treeViewPath,

              // displayName: treeElement.parent?.parent?.name + ' | ' + (treeElement.description || treeViewProperties.measure),
              // unit: treeElement.unit || '',
              // tree: treeElement.tree,
              // description:
              //   treeElement.parent?.parent?.name +
              //   ' (' +
              //   treeViewProperties.measure.slice(0, treeViewProperties.measure.indexOf('@')) +
              //   ')',
              // measureType: treeElement.description,
              source: metricOutput.source,
              metrics: metricOutput.metrics
            } as TimestreamMetric;
            /*
            const equipment = equipments.find(e => e.id === treeViewProperties.category);
            if (!equipment) {
              console.log('wrong kiara tag, should not appear again');
              return;
            }
            const property = equipment.properties.find(p => p.name === treeViewProperties.measure);
            const measuringPoint = equipment.measuringPoints.find(mp => mp.id === property.measuringPointId);
            const simType = +treeViewProperties.simulation as SimulationType;
            const equipmentName = TreeViewHelper.showPathInTreeView(treeView, treeViewPath.slice(0, 5))?.name || '';

            const metric: TimestreamMetric = {
              key: treeViewProperties.key,
              simulationType: simType,
              category: equipment.id,
              unit: property.unit,
              ouvrage: treeViewProperties.ouvrage,
              description: equipmentName,
              metricSource: TreeViewSourceType.KIARA,
              measureType: measuringPoint ? measuringPoint.displayName : property.displayName,
              measureSource: property.panel === Panel.MEASURED ? MeasureSource.MEASURE : MeasureSource.RESULT,
              displayName: `${equipmentName} | ${
                measuringPoint ? measuringPoint.displayName : property.displayName
              } | ${property.panel === Panel.MEASURED ? 'Mesure' : 'Résultat'} - ${
                simType === SimulationType.PRSIM ? 'Temps réel' : 'Horaire'
              }`,
              // hasGasX: measuringPoint?.values.some(v => v.type === MeasuringPointType.GASX) ?? false,
              ...metricOutput,
              property: treeViewProperties.property
            };*/
            metrics.push(metric);
          });

          copy = {
            ...component,
            curve: { ...component.curve, chart: { start, end, metrics } }
          };
        }
      }

      components.push(copy);
    });

    return { ...dashboard, components: components };
  }
);

export const getDashboardsLimitedData = createSelector(
  getDashboards,
  getDashboard,
  (dashboards: Dashboard[], dashboard): DashboardLimitedData[] =>
    dashboards.length > 0
      ? dashboards.filter(dash => dashboard?.id !== dash?.id).map(dash => ({ id: dash.id, name: dash.name }))
      : []
);

export const getPublicFavoritePaths = createSelector(
  fromCore.getFavoritePaths,
  (favoritePath: FavoritePath[]): FavoritePath[] => favoritePath.filter(path => path.isPublic)
);
/*
export const getMultiTreeViews = createSelector(
  fromCore.getTreeViewSources,
  getSimulatedTreeView,
  (treeViewSources, sources) => {
    const multiTreeView = [];
    treeViewSources.forEach(source => {
      if (source.enabled) {
        multiTreeView.push(TreeViewHelper.getTreeView(source.name));
      }
    });
    return multiTreeView;
  }
);*/
